import {
  Box,
  Button,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SaveIcon from "@mui/icons-material/Save";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { showErrorSnackbar, showSuccessSnackbar } from "../snackBar/snakbar";
import { LoadingButton } from "@mui/lab";
import { useThemes } from "../Theme/theme";
import { axiosInstanceForLambda } from "../../library/Axios";
import OpeningBalanceDateModal from "../modals/OpeningBalanceDateModal";
import dayjs from "dayjs";
import { SkipNext } from "@mui/icons-material";
import API_ENDPOINTS from "../../apiEndpoints";

function ImportSummary({
  summaryDetails,
  setSummaryDetails,
  module,
  file,
  isOpenModal,
  onClose,
  setSummaryView,
  onConfirm,
  onReset,
}) {
  const { theme } = useThemes();

  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const sortedData = summaryDetails?.data
    ?.sort((a, b) => a.rowIndex - b.rowIndex)
    ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const handleSuccessRecord = async (skip = false) => {
    try {
      if (isOpenModal?.isActive) {
        onClose(true);
        return;
      }
      setLoading(true);
      const splitText = module.split("-");
      const moduleName = splitText[1] || splitText[0];
      const body_data = {
        moduleType: moduleName,
        file_key: file.name,
        skip: skip,
      };

      if (moduleName === "Accounts") {
        body_data.openingBalanceDate = dayjs(isOpenModal?.date).unix();
      }

      const options = {
        method: "POST",
        url: API_ENDPOINTS.IMPORT_DATA_URL,
        data: body_data,
      };

      const response = await axiosInstanceForLambda(options);
      if (response && response?.status === 200) {
        showSuccessSnackbar("Data imported successfully");
        onReset();
      }
    } catch (error) {
      const errorMessage =
        error?.response?.data?.data?.error ||
        error?.response?.data?.message ||
        error?.message;
      showErrorSnackbar(errorMessage);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
      <Typography variant="h1" sx={{ fontWeight: "bold" }}>
        Import Summary
      </Typography>
      <ul>
        <li>
          {summaryDetails?.totalCount - summaryDetails?.invalidCount} out of{" "}
          {summaryDetails?.totalCount} items successfully validated and are
          ready for import.
        </li>
        <li>
          {summaryDetails?.invalidCount} items failed validation and require
          corrections.
        </li>
      </ul>
      <Box sx={{ marginLeft: 4, marginBottom: 2 }}>
        {summaryDetails?.data.length > 0 && (
          <Paper>
            <TableContainer component={Paper}>
              <Table
                sx={{ minWidth: 650, border: "1px solid #ccc" }}
                aria-label="simple table"
              >
                <TableHead>
                  <TableRow
                    sx={{ backgroundColor: "primary.main", color: "white" }}
                  >
                    <TableCell
                      sx={{ color: "white", border: "1px solid #ccc" }}
                    >
                      Row
                    </TableCell>
                    <TableCell
                      sx={{ color: "white", border: "1px solid #ccc" }}
                    >
                      Description
                    </TableCell>
                    <TableCell
                      sx={{ color: "white", border: "1px solid #ccc" }}
                    >
                      Status
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sortedData?.map((summary) => (
                    <TableRow
                      key={summary.rowIndex}
                      sx={{ border: "1px solid #ccc" }}
                    >
                      <TableCell
                        sx={{ fontWeight: "bold", border: "1px solid #ccc" }}
                      >
                        {summary?.rowIndex}
                      </TableCell>
                      <TableCell
                        sx={{ fontWeight: "bold", border: "1px solid #ccc" }}
                      >
                        {summary?.description}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: "red",
                          fontWeight: "bold",
                          border: "1px solid #ccc",
                        }}
                      >
                        {summary?.status}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={summaryDetails?.data?.length || 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        )}
      </Box>

      <Stack direction="row" spacing={2}>
        <Button
          variant="outlined"
          sx={{ fontSize: "14px" }}
          onClick={() => setSummaryView(false)}
        >
          Modify & Re-upload
        </Button>

        <LoadingButton
          disabled={
            !(
              summaryDetails?.totalCount > 0 &&
              summaryDetails?.invalidCount === 0
            )
          }
          loading={loading}
          loadingPosition="start"
          color="primary"
          onClick={() => handleSuccessRecord()}
          startIcon={<SaveIcon />}
          variant="contained"
        >
          Import Successful Records
        </LoadingButton>

        {summaryDetails?.totalCount > 0 && summaryDetails?.invalidCount > 0 && (
          <LoadingButton
            disabled={
              summaryDetails?.totalCount - summaryDetails?.invalidCount === 0
            }
            loading={loading}
            loadingPosition="start"
            color="primary"
            onClick={() => handleSuccessRecord(true)}
            startIcon={<SkipNext />}
            variant="contained"
          >
            Import Valid Records
          </LoadingButton>
        )}
      </Stack>

      <OpeningBalanceDateModal
        open={isOpenModal.modal}
        onClose={onClose}
        onConfirm={onConfirm}
      />
    </div>
  );
}

export default ImportSummary;
